<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>商品待入库列表</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <div
      v-if="resData"
      class="row"
      :gutter="20"
      type="flex"
      align="middle"
      justify="start"
    >
      <div
        v-for="item in resData.optionsOrigin"
        v-if="item.key !== -1"
        :key="item.key"
        class="status"
        :class="{ active: origin === item.key }"
        @click="selectOrigin(item.key)"
      >
        {{ item.label }}
      </div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-col :span="24">
                <el-form :inline="true" :model="form" class="demo-form-inline">
                  <el-form-item label="输入搜索：">
                    <el-input
                      v-model="form.goods_no"
                      placeholder="商品货号"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.sku"
                      placeholder="sku"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.goods_name"
                      placeholder="商品名称"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.supply_name"
                      placeholder="商家"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.market_name"
                      placeholder="市场"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.brand_name"
                      placeholder="品牌"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item v-if="resData">
                    <el-select v-model="form.pgid" placeholder="选择代采组">
                      <el-option
                        v-for="item in resData.optionsPg"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="resData">
                    <el-select
                      v-model="form.picker_group"
                      placeholder="选择买手组"
                    >
                      <el-option
                        v-for="item in resData.optionsMs"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="resData">
                    <el-select
                      v-model="form.order_owner"
                      filterable
                      placeholder="订单负责人"
                    >
                      <el-option :key="0" value="0" label="全部"></el-option>
                      <el-option
                        v-for="item in resData.owner_option"
                        :key="item.value"
                        :value="item.value"
                        :label="item.label"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select v-model="form.type" placeholder="选择入库来源">
                      <el-option
                        v-for="item in resData.optionsType"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.dgid"
                      filterable
                      placeholder="次品组"
                    >
                      <el-option label="全部" value=""></el-option>
                      <el-option
                        v-for="item in resData.dg_group"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.dpc_id"
                      filterable
                      placeholder="退换货负责人"
                    >
                      <el-option label="全部" value=""></el-option>
                      <el-option
                        v-for="item in resData.option_dgm"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.refunder_id"
                      filterable
                      placeholder="售后退供员"
                    >
                      <el-option label="全部" value=""></el-option>
                      <el-option
                        v-for="item in resData.dgm_refunder"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </el-col>
            </div>
            <div style="padding: 0 25px">
              <el-form
                v-if="resData"
                :inline="true"
                :model="form"
                class="demo-form-inline"
              >
                <el-form-item label="打标时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['06:00:00', '06:00:00']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="form.origin" placeholder="选择仓库">
                    <el-option
                      v-for="item in resData.optionsOrigin"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <el-row>
      <el-col v-if="resData" :span="24" class="data-statics">
        数据汇总&nbsp;&nbsp;&nbsp;&nbsp;待入库总数{{
          resData.count
        }}件&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;待入库金额：¥{{
          resData.stock_total_price
        }}
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-row v-if="!loading">
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-button
            style="margin-left: auto"
            :disabled="reCallButtonDisabled"
            size="mini"
            type="danger"
            @click="reCallDbids"
            >删除</el-button
          >
          <el-button type="success" size="mini" @click="oweRebackApply">
            申请恢复欠货
          </el-button>
          <el-button type="success" size="mini" @click="output">导出</el-button>
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="right"
              type="selection"
              width="55"
            ></el-table-column>
            <el-table-column
              prop="dbid"
              label="打标id"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="goods_img"
              label="商品图片"
              width="120"
              align="center"
            >
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    style="width: 100%; height: 100%"
                    :src="scope.row.goods_img"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="goods_name"
              label="商品名称"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              v-if="where === 3"
              prop="blp_img"
              label="换回商品图片"
              width="120"
              align="center"
            >
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    style="width: 100%; height: 100%"
                    :src="scope.row.blp_img"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="goods_no"
              label="商品货号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="co_val"
              label="颜色"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="si_val"
              label="尺码"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="sku"
              label="sku"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="da_biao_record_stock_source"
              label="入库来源"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="da_biao_record_type"
              label="类型"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="market_name"
              label="市场"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="brand_name"
              label="品牌"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pg_name"
              label="买手组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pgname"
              label="代采组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="owner_admin_name"
              label="订单负责人"
              show-overflow-tooltip
              align="center"
            ></el-table-column>

            <el-table-column
              prop="dg_group_name"
              label="次品组"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="dgm_name"
              label="退换货负责人"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="refunder"
              label="售后退供员"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="origin"
              label="仓库"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="create_admin"
              label="打标人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="打标时间"
              width="100"
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper,sizes "
            :total="resData.count"
            :page-size="form.page_sizes"
            :page-sizes="[10, 20, 50, 100]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="申恢复欠货"
      :visible.sync="isShowRebackDialog"
      width="600px"
      @close="isShowRebackDialog = false"
    >
      <el-form label-position="left" label-width="80px">
        <el-form-item label="申请数量: ">{{
          form.multipleSelection.length
        }}</el-form-item>
        <el-form-item label="申请说明: ">
          <el-input
            v-model="oweRebackApplyRemark"
            type="textarea"
            :rows="6"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="isShowRebackDialog = false">取 消</el-button>
        <el-button type="primary" @click="doApplyReback">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: null,
      form: {
        create_time: this.$excalibur.getDateTimeOnHours(-3, 6),
        page_sizes: 10,
        multipleSelection: [],
      },
      loading: false,
      url: "/erp/StockInRecord/stockRecordList",
      origin: 1,
      where: -1,
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      isShowRebackDialog: false,
      oweRebackApplyRemark: "",
      selectionDbid: [],
      reCallButtonDisabled: false,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  // created() {
  //   this.fetchData();
  // },
  methods: {
    handleSizeChange($val) {
      this.form.page_sizes = $val;
      this.fetchData(true);
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      let can_recall = false;
      this.selectionDbid = [];
      for (const key in val) {
        multipleSelection[key] = val[key].dbrid;
        this.selectionDbid[key] = val[key].dbid;
        // 如果存在不能删除的dbid 删除按钮禁用
        if (!val[key].can_recall) {
          can_recall = true;
        }
      }
      this.form.multipleSelection = multipleSelection;
      this.reCallButtonDisabled = can_recall;
    },
    onSubmit() {},
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.form).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleClick(row) {
      this.$router.push(`/home/purchaseorderdetail/${row.woid}`);
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$set(this.form.multipleSelection, "length", 0);
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.origin = this.filteredForm.origin;
          this.where = this.filteredForm.where;
          this.curPage = 1;
        }
      });
    },
    selectOrigin(key) {
      this.form.origin = this.origin = key;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    selectWhere(key) {
      this.form.where = this.where = key;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    oweRebackApply() {
      if (this.form.multipleSelection.length == 0)
        return this.$message.error("请先勾选");
      this.isShowRebackDialog = true;
      this.oweRebackApplyRemark = "";
    },
    doApplyReback() {
      this.$http
        .post("/erp/OweReback/oweRebackApply", {
          dbids: this.selectionDbid,
          remark: this.oweRebackApplyRemark,
        })
        .then((rs) => {
          if (rs.data.code != 200) return this.$message.error(rs.data.msg);
          this.$message.success("申请成功! 请等待审核");
          this.isShowRebackDialog = false;
        })
        .catch(() => {
          this.$message.error("服务器错误! 请联系管理员");
        });
    },
    reCallDbids() {
      if (this.form.multipleSelection.length <= 0) {
        return this.$message.e("请选勾选要删除的dbid");
      }
      this.$confirm("确定删除选中的dbid吗？", "提示").then(() => {
        this.$http
          .post("/erp/StockInRecord/pcReCallDbids", {
            dbids: this.selectionDbid,
          })
          .then((res) => {
            const { data, code, msg } = res.data;
            if (code !== 200) {
              return this.$message.e(msg);
            }
            this.fetchData(true);
            return this.$message.success("删除成功");
          });
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1 px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/WarehousingList.vue